<template>
  <div class="d-flex flex-v-center flex-justify-between pd-b-small mn-b-small" :class="isLast ? '' : 'br-b-1px br-grey-transp-15'">
    <div class="d-flex flex-v-center gap-regular">
      <div class="d-flex flex-v-center flex-justify-center w-2r h-2r radius-small bg-light">
        <span class="p-regular">{{ providerIcon }}</span>
      </div>
      <div>
        <p class="p-regular fw-medium">{{ payment.description || $t('payments.title') }}</p>
        <p class="p-small t-grey">{{ formattedDate }}</p>
      </div>
    </div>
    <div class="t-right">
      <p class="p-regular fw-medium" :class="statusColor">{{ formattedAmount }}</p>
      <p class="p-small" :class="statusColor">{{ $t(`payments.statuses.${payment.status}`) }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  payment: { type: Object, required: true },
  isLast: { type: Boolean, default: false },
});

const providerIcon = computed(() => {
  const icons = { yookassa: '💳', stripe: '💳', wallet: '👛' };
  return icons[props.payment.provider] || '💳';
});

const formattedAmount = computed(() => {
  const value = props.payment.amount?.value || 0;
  const currency = props.payment.amount?.currency || 'RUB';
  return `${(value / 100).toLocaleString('ru-RU')} ${currency === 'RUB' ? '₽' : currency}`;
});

const formattedDate = computed(() => {
  const d = new Date(props.payment.createdAt);
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short', year: 'numeric' });
});

const statusColor = computed(() => {
  const colors = {
    succeeded: 't-main',
    failed: 't-red',
    canceled: 't-grey',
    refunded: 't-orange',
    pending: 't-grey',
    created: 't-grey',
    waiting_for_capture: 't-second',
  };
  return colors[props.payment.status] || 't-dark';
});
</script>
